/**
 * Capitalizes the first letter of the provided string
 * @param stringToCapitalize
 */
export function capitalize(stringToCapitalize: string): string {
    if (stringToCapitalize) {
        return stringToCapitalize[0].toUpperCase() + stringToCapitalize.slice(1);
    }

    // Else return empty string
    return ``;
}
